// Generated by ReScript, PLEASE EDIT WITH CARE

import * as MomentTz$Catalyst from "../moment-time-zone-bindings/MomentTz.bs.js";
import * as TimeUnit$Catalyst from "../TimeUnit.bs.js";
import * as ScaleUnit$Catalyst from "../../time-stamp/ScaleUnit.bs.js";

var setTz = MomentTz$Catalyst.setTz;

function now(param) {
  return MomentTz$Catalyst.momentNow(undefined);
}

var toFloat = MomentTz$Catalyst.valueOf;

var fromTimestampMs = MomentTz$Catalyst.momentWithTimestampMS;

function formatFromFloat(format, timestamp) {
  return MomentTz$Catalyst.format(MomentTz$Catalyst.momentWithTimestampMS(timestamp), format);
}

function formatFromJsDate(format, date) {
  return MomentTz$Catalyst.format(MomentTz$Catalyst.momentWithDate(date), format);
}

var fromJsDate = MomentTz$Catalyst.momentWithDate;

var toJsDate = MomentTz$Catalyst.toJsDate;

var fromString = MomentTz$Catalyst.momentWithFormat;

var isBefore = MomentTz$Catalyst.isBefore;

var isAfter = MomentTz$Catalyst.isAfter;

function getDateTimeAfterElapsedTime(elapsed_time, time_unit, initial_date) {
  return MomentTz$Catalyst.getDateTimeAfterElapsedTime(elapsed_time, TimeUnit$Catalyst.toMomentTimeUnit(time_unit), initial_date);
}

function getDateTimeBeforeElapsedTime(elapsed_time, time_unit, initial_date) {
  return MomentTz$Catalyst.getDateTimeBeforeElapsedTime(elapsed_time, TimeUnit$Catalyst.toMomentTimeUnit(time_unit), initial_date);
}

function startOf(moment, scale) {
  return MomentTz$Catalyst.startOf(moment, ScaleUnit$Catalyst.toMomentScaleUnit(scale));
}

function endOf(moment, scale) {
  return MomentTz$Catalyst.endOf(moment, ScaleUnit$Catalyst.toMomentScaleUnit(scale));
}

var day = MomentTz$Catalyst.day;

export {
  setTz ,
  now ,
  toFloat ,
  formatFromJsDate ,
  formatFromFloat ,
  fromTimestampMs ,
  fromJsDate ,
  toJsDate ,
  fromString ,
  isBefore ,
  isAfter ,
  getDateTimeAfterElapsedTime ,
  getDateTimeBeforeElapsedTime ,
  startOf ,
  endOf ,
  day ,
  
}
/* MomentTz-Catalyst Not a pure module */
